/**
 * Created by Jie Gao on 2020-09-25.
 */
import {
    GameIntroColors,
    GameIntroViewConfig, StampConfig, Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {WixxGameAssets} from "../WixxGameAssets";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {WixxSlideShowPage} from "./WixxSlideShowPage";

interface IPagesConfig {
    name: string,
    textTexture: string,
    loopStart: number,
    loopTill: number
}

export class WixxIntroConfig implements GameIntroViewConfig {

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0.4, //Default 0.4
            bulletColor: 0xffffff, //Default 0xffffff
        },
        stampColor: 0xFFFFFF
    };

    stampConfig: StampConfig = {
        xWays: false,
        xNudge: false,
        volatility: Volatility.MEDIUM
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];

    private _pagesConfig: IPagesConfig[] = [
        {
            name: WixxIntroConfig.INTRO_FEATURE_1_ANIMATE,
            loopStart: 0,
            loopTill: 49,
            textTexture: WixxIntroConfig.INTRO_FEATURE_1_TEXT
        },
        {
            name: WixxIntroConfig.INTRO_FEATURE_2_ANIMATE,
            loopStart: 0,
            loopTill: 49,
            textTexture: WixxIntroConfig.INTRO_FEATURE_2_TEXT
        },
        {
            name: WixxIntroConfig.INTRO_FEATURE_3_ANIMATE,
            loopStart: 0,
            loopTill: 49,
            textTexture: WixxIntroConfig.INTRO_FEATURE_3_TEXT
        }
    ];
    public static INTRO_BG = WixxGameAssets.INTRO_BACKGROUND;
    public static INTRO_BACKGROUND_PORTRAIT = WixxGameAssets.INTRO_BACKGROUND_PORTRAIT;
    public static INTRO_LOGO = WixxGameAssets.INTRO_LOGO;
    public static INTRO_FEATURE_1_TEXT = WixxGameAssets.INTRO_FEATURE_0_TEXT;
    public static INTRO_FEATURE_2_TEXT = WixxGameAssets.INTRO_FEATURE_1_TEXT;
    public static INTRO_FEATURE_3_TEXT = WixxGameAssets.INTRO_FEATURE_2_TEXT;
    public static INTRO_FEATURE_1_ANIMATE = WixxGameAssets.INTRO_FEATURE_0_ANIMATE;
    public static INTRO_FEATURE_2_ANIMATE = WixxGameAssets.INTRO_FEATURE_1_ANIMATE;
    public static INTRO_FEATURE_3_ANIMATE = WixxGameAssets.INTRO_FEATURE_2_ANIMATE;
    public static INTRO_FEATURE_SPOTLIGHT = WixxGameAssets.INTRO_FEATURE_SPOTLIGHT;

    //public static LAYOUT = "resources/images/image.png";

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(WixxIntroConfig.INTRO_BG, WixxIntroConfig.INTRO_BG);
        imgLoader.add(WixxIntroConfig.INTRO_BACKGROUND_PORTRAIT, WixxIntroConfig.INTRO_BACKGROUND_PORTRAIT);
        imgLoader.add(WixxIntroConfig.INTRO_LOGO, WixxIntroConfig.INTRO_LOGO);
        imgLoader.add(WixxIntroConfig.INTRO_FEATURE_SPOTLIGHT, WixxIntroConfig.INTRO_FEATURE_SPOTLIGHT);
        //imgLoader.add(WixxIntroConfig.LAYOUT,WixxIntroConfig.LAYOUT);

        this._pagesConfig.forEach((pageConfig: IPagesConfig, i: number) => {
            for (let j: number = pageConfig.loopStart; j <= pageConfig.loopTill; j++) {
                let name: string = pageConfig.name;
                name = pageConfig.name;
                name += (((j < 10) ? "00" : "0") + j.toString() + ".png");
                imgLoader.add(name,name)
            }
            imgLoader.add(pageConfig.textTexture, pageConfig.textTexture);
        });

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture(WixxIntroConfig.INTRO_BG));
        bgSprite.anchor.set(0.5, 0.5);
        bgSprite.scale.set(1,1.5);
        this.background.addChild(bgSprite);

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture(WixxIntroConfig.INTRO_LOGO));
        logoSprite.blendMode = PIXI.BLEND_MODES.ADD;
        logoSprite.anchor.set(0.5, 0.55);
        this.logo.addChild(logoSprite);
        this.borderTop = new PIXI.Container();
        this.borderBottom = new PIXI.Container();
        this.pages = [];
        this._pagesConfig.forEach((pageConfig: IPagesConfig, i: number) => {

            const pageTextures: PIXI.Texture[] = [];

            for (let j: number = pageConfig.loopStart; j <= pageConfig.loopTill; j++) {
                let name: string = pageConfig.name;
                name = pageConfig.name;
                name += (((j < 10) ? "00" : "0") + j.toString() + ".png");
                pageTextures.push(ImgLoader.getImgTexture(name));
            }
            this.pages.push(new WixxSlideShowPage(pageTextures, 30, ImgLoader.getImgTexture(pageConfig.textTexture)))
        });
    }
}
